import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Media from 'react-media';

import './NosMarques.scss';

const NosMarques = props => {
  const {
    marquesBannerTitle,
    logosMarquesFull,
    logosMarquesSmall,
    marquesBannerBody,
  } = props;

  return (
    <div className={(props.className || '') + ' nos-marques'}>
      <h1>{marquesBannerTitle}</h1>

      <Media query={{ minWidth: '768px' }}>
        {matches =>
          matches ? (
            // si plus grand que 768px =>
            <div className="brand-logos">
              <Img
                alt={logosMarquesFull.title}
                sizes={logosMarquesFull.sizes}
              />
            </div>
          ) : (
            <div className="brand-logos">
              <Img
                alt={logosMarquesSmall.title}
                sizes={logosMarquesSmall.sizes}
              />
            </div>
          )
        }
      </Media>

      <div
        className="nos-marques-text"
        dangerouslySetInnerHTML={{ __html: marquesBannerBody }}
      />
    </div>
  );
};

NosMarques.propTypes = {
  className: PropTypes.string,
  marquesBannerTitle: PropTypes.string,
  logosMarquesFull: PropTypes.object,
  logosMarquesSmall: PropTypes.object,
  marquesBannerBody: PropTypes.string,
};

export default NosMarques;



// WEBPACK FOOTER //
// ./src/components/Main/home/NosMarques.js